import type { AdminSearchResultItem } from '../types';
import AssetPickerTypes from '~/components/common/asset-picker/asset-picker-types';
import { GuideSubTypes } from '../constants';

export const getAdminSearchResultUrl = (item: AdminSearchResultItem): string => {
  // Special handling for guide sections
  if (item.type === GuideSubTypes.SECTION && item.guide?.id) {
    return `/admin/guides/${item.guide.id}/edit_section/${item.id}`;
  }
  return AssetPickerTypes.getItemAdminUrl({ id: item.id, type: item.type });
};

export const openAdminSearchResult = (item: AdminSearchResultItem) => {
  const url = getAdminSearchResultUrl(item);
  return window.location.assign(url);
};
